<script setup>
import { ref, onUnmounted } from "vue";
import VueApexCharts from "vue3-apexcharts";
import useServiceChart from "../hooks/useServiceChart.js";
import Utils from "@/common/utils";

const {
  loadReport: loadSericeType1,
  data: chartDataType1,
  total: total1,
} = useServiceChart(1);
const {
  loadReport: loadSericeType2,
  data: chartDataType2,
  total: total2,
} = useServiceChart(2);

loadSericeType1();
loadSericeType2();

const chartWidth = ref(500);
const resizeChartWidth = () => {
  chartWidth.value = window.innerWidth <= 1440 ? 400 : 500;
};
window.addEventListener("resize", resizeChartWidth);
resizeChartWidth();

onUnmounted(() => {
  window.removeEventListener("resize", resizeChartWidth);
});
</script>

<template>
  <div class="ras-charts">
    <h2 class="ras-charts__header">Услуги</h2>

    <div class="row">
      <div class="col-6 ras-charts__services">
        <div class="ras-charts__total">
          Итого: {{ total2 }} {{ Utils.getServiceWordByCount(total2.value) }}
        </div>
        <VueApexCharts
          v-bind="chartDataType2"
          :key="chartWidth"
          :width="chartWidth"
        />
      </div>
      <div class="col-6 ras-charts__services">
        <div class="ras-charts__total">
          Итого: {{ total1 }} {{ Utils.getServiceWordByCount(total1.value) }}
        </div>
        <VueApexCharts
          v-bind="chartDataType1"
          :key="chartWidth"
          :width="chartWidth"
        />
      </div>
    </div>

    <div class=""></div>
  </div>
</template>

<style lang="scss">
// .ras-charts__services .vue-apexcharts {
//   height: 330px;
// }
</style>
